import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Brand from './layout/Brand';
import { navigation } from './layout/navigation';

const Sidebar = ({ compact, mobileOpen, onClose, onExpand }) => {
  const { pathname } = useLocation();
  const drawer = useRef(null);
  const activeGroup = navigation.find(group => group.items.some(item => item.path === pathname))?.label;
  const [openGroup, setOpenGroup] = useState(activeGroup);
  useEffect(() => { setOpenGroup(activeGroup); }, [activeGroup]);
  useEffect(() => {
    if (!mobileOpen) return undefined;
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    drawer.current?.querySelector('button')?.focus();
    const closeOnEscape = event => {
      if (event.key === 'Escape') onClose();
      if (event.key === 'Tab') {
        const targets = drawer.current?.querySelectorAll('a[href], button:not(:disabled)');
        if (!targets?.length) return;
        const first = targets[0], last = targets[targets.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', closeOnEscape);
    return () => { document.removeEventListener('keydown', closeOnEscape); document.body.style.overflow = previousOverflow; if (previousFocus?.isConnected) previousFocus.focus(); };
  }, [mobileOpen, onClose]);
  return <>
    {mobileOpen && <button className="workspace-menu-backdrop" type="button" aria-label="Fechar navegação" onClick={onClose} />}
    <aside ref={drawer} role={mobileOpen ? 'dialog' : undefined} aria-modal={mobileOpen ? true : undefined} aria-label={mobileOpen ? 'Navegação' : undefined} className={`workspace-sidebar ${mobileOpen ? 'is-open' : ''}`}>
      <button className="workspace-icon-button workspace-drawer-close" type="button" aria-label="Fechar menu" onClick={onClose}><i className="mdi mdi-close" aria-hidden="true" /></button>
      <Link className="workspace-brand-link" to="/gesture-map" onClick={onClose}><Brand /></Link>
      <nav id="workspace-navigation" aria-label="Navegação principal">
        <span className="workspace-nav-caption">Sua operação</span>
        {navigation.map((group, index) => <div className="workspace-nav-group" key={group.label}>
          {index === 0 ? group.items.map(item => <NavLink exact to={item.path} key={item.path} title={compact ? item.label : undefined} className="workspace-nav-link" activeClassName="is-active" onClick={onClose}><i className={`mdi mdi-${item.icon}`} aria-hidden="true" /><span>{item.label}</span></NavLink>) : <>
            <button type="button" className={`workspace-nav-link workspace-nav-group-toggle ${activeGroup === group.label ? 'has-active' : ''}`} title={compact ? group.label : undefined} aria-expanded={!compact && openGroup === group.label} aria-controls={`nav-group-${index}`} onClick={() => { if (compact) onExpand(); setOpenGroup(openGroup === group.label && !compact ? null : group.label); }}>
              <i className={`mdi mdi-${group.icon}`} aria-hidden="true" /><span>{group.label}</span><i className={`mdi mdi-chevron-${openGroup === group.label ? 'up' : 'down'} workspace-nav-chevron`} aria-hidden="true" />
            </button>
            {!compact && openGroup === group.label && <div id={`nav-group-${index}`} className="workspace-nav-children">{group.items.map(item => <NavLink exact to={item.path} key={item.path} className="workspace-nav-link" activeClassName="is-active" onClick={onClose}>{item.label}</NavLink>)}</div>}
          </>}
        </div>)}
      </nav>
      <div className="workspace-sidebar-foot"><span className="workspace-product-mark">TK</span><span>Gestão de frotas<small>Controle em cada percurso</small></span></div>
    </aside>
  </>;
};
export default Sidebar;
